<template>
    <div id="nav">
        <router-view/>
    </div>
</template>

<script>
import 'vfonts/FiraSans.css'
export default {
    name: 'App',
}
</script>

<style>

:root {
    padding-left: 50px;
}

</style>
